/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-06 14:28:53
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';
import { Button } from '@shopify/polaris';
import { showChatbox } from 'src/integrations/chatbox';
import history from 'src/routes/history';
import { LARGE_PRODUCT } from 'src/constants/subscription';

import ReviewPackageModal from './review-modal';
import ReviewPackageUpsellModal from './review-modal.upsell';
import StatusModal from 'src/components/views/subscription-v3/modal/status-modal';
import TermsConditionsModal from 'src/components/views/subscription-v3/terms-conditions-modal';
import RequestLargeModal from 'src/components/views/subscription-v3/package/request-large-modal';
import * as subscriptionV3Actions from 'src/stores/actions/subscription-v3-actions';

import { checkUsingVariantForFree } from 'src/helpers/subscription-v3-helper';

//--------------------------
// Plan Summary
const ActionChoosePackage = props => {
  const {
    i18n,
    primary = false,
    host,
    correctPlan = {},
    storeStatus,
    disabled = false,
    subscribe,
    discount,
    verifying,
    msgVerifyError,
    clearDiscountCode,
    verifyDiscountCode,
    allowApplyDiscountCode = true,
    invoice,
    packagePlans = [],
    termsConditions,
    gettingInvoice,
    remainCycles,
    subscribing,
    packageInfo,
    products = 0,
    currentTotalProducts = 0,
    tenantApp,
    packageSelected,
    setUpsellPackage,
    allPackagePlans,
    packageNameType,
    selectedPlan,
    isForExpireExceed,
    activeSelectPackage = false
  } = props;

  const [open, setOpen] = useState(false);
  const [openRequestLarge, setOpenRequestLarge] = useState(false);
  const [openModalStatus, setOpenModalStatus] = useState(false);
  const [openTC, setOpenTC] = useState(false);
  const [correctPackage, setCorrectPackage] = useState({});

  // init value
  const currentPlanProducts = _.get(invoice, 'chargeInfo.products', 0);
  const termsConditionsContent = _.get(termsConditions, 'content', '');
  // use effect
  useEffect(() => {
    if (!_.isEmpty(correctPlan)) {
      setCorrectPackage(correctPlan);
      return;
    }
    let matchPackage;
    if (isForExpireExceed && currentTotalProducts > LARGE_PRODUCT) {
      matchPackage = {
        name: 'request_large_plan',
        products: '50,000+',
        price: packagePlans.find(e => e.products >= currentTotalProducts)?.price
      };
      setCorrectPackage(matchPackage);
      return;
    }

    if (products > 0) {
      matchPackage = packagePlans.find(packageOffer => packageOffer.products === products);
      setCorrectPackage(matchPackage);
      return;
    }
    // In case total product large
    if (currentTotalProducts > LARGE_PRODUCT) {
      matchPackage = {
        name: 'request_large_plan',
        products: '50,000+',
        price: packagePlans.find(e => e.products >= currentTotalProducts)?.price
      };
    } else {
      matchPackage = packagePlans.find(packageOffer =>
        currentPlanProducts > LARGE_PRODUCT
          ? packageOffer.products >= currentTotalProducts
          : packageOffer.products >= currentPlanProducts
      );
    }
    setCorrectPackage(matchPackage);
  }, [products]);

  // Check if open corresponding package modal from url state
  useEffect(() => {
    if (activeSelectPackage) {
      setOpen(true);
    }
  }, []);

  let contentAction =
    _.get(correctPackage, 'name', '') === 'request_large_plan'
      ? 'requestLargePlan'
      : 'choosePackage';
  if (isForExpireExceed && packageSelected === '50,000+') {
    contentAction = 'requestLargePlan';
  } else if (isForExpireExceed) {
    contentAction = 'upgradePackage';
  }

  // Render function
  // open term and condition
  const handledTermNCondition = useCallback(() => {
    setOpenTC(!openTC);
    // setOpen(!open);
  }, [open, openTC]);

  // Open beacon chat
  const handleSupport = () => {
    setOpenModalStatus(false);
    showChatbox();
  };

  // Render content modal status error
  const renderContentSubscribeError = () => {
    return {
      status: 'error',
      handleAction: () => {
        setOpenModalStatus(true);
        setOpen(false);
      }
    };
  };

  // handle subscribe
  const handleSubscribe = useCallback(
    async (addonList, code) => {
      if (_.isEmpty(correctPackage)) return;
      await subscribe(correctPackage.name, code, host, addonList).then(response => {
        const { type = '' } = response;
        if (type === 'SUBSCRIBE_PLAN_FAILURE') {
          setOpenModalStatus(true);
          setOpen(false);
          clearDiscountCode();
        }
      });
    },
    [correctPackage]
  );

  const handleOpenModal = () => {
    if (correctPackage?.name === 'request_large_plan') {
      setOpenRequestLarge(true);
    } else setOpen(true);
  };

  const useFreeVariant = checkUsingVariantForFree(tenantApp);

  const handleCancelPackage = useCallback(() => {
    setOpen(false);
  }, []);

  const handleCancelRequestLargeModal = useCallback(() => {
    setOpenRequestLarge(false);
  }, []);

  const changeCorrectPlan = useCallback((name, products: number, cb = () => {}) => {
    const packagePlans = allPackagePlans[name];

    if (products > 0) {
      const matchPackage = packagePlans.find(packageOffer => packageOffer.products === products);
      setCorrectPackage(matchPackage);
    }
    cb();
  }, []);

  return (
    <>
      {primary ? (
        <Button disabled={disabled} onClick={() => handleOpenModal()} primary>
          {i18n.translate(`AdminHTML.SubscriptionV3.Actions.${contentAction}`)}
        </Button>
      ) : (
        <Button disabled={disabled} onClick={() => handleOpenModal()}>
          {i18n.translate(`AdminHTML.SubscriptionV3.Actions.${contentAction}`)}
        </Button>
      )}
      {/* Review info package selected */}
      {selectedPlan === '' && (
        <ReviewPackageModal
          packageNameType={packageNameType}
          active={open}
          allowApplyDiscountCode={allowApplyDiscountCode}
          discount={discount || {}}
          verifying={verifying}
          msgVerifyError={msgVerifyError}
          packageInfo={packageInfo}
          handledTermNCondition={handledTermNCondition}
          correctPlan={correctPackage}
          changeCorrectPlan={changeCorrectPlan}
          verifyDiscountCode={verifyDiscountCode}
          clearDiscountCode={clearDiscountCode}
          handleCancel={handleCancelPackage}
          handleConfirm={handleSubscribe}
          invoice={invoice}
          gettingInvoice={gettingInvoice}
          storeStatus={storeStatus}
          remainCycles={remainCycles}
          history={history}
          subscribing={subscribing}
          useFreeVariant={useFreeVariant}
          packageSelected={packageSelected}
          setUpsellPackage={e => {
            setUpsellPackage(e);
          }}
        />
      )}
      {selectedPlan !== '' && (
        <ReviewPackageUpsellModal
          packageNameType={packageNameType}
          active={open}
          allowApplyDiscountCode={allowApplyDiscountCode}
          discount={discount || {}}
          verifying={verifying}
          msgVerifyError={msgVerifyError}
          packageInfo={packageInfo}
          handledTermNCondition={handledTermNCondition}
          correctPlan={correctPackage}
          changeCorrectPlan={changeCorrectPlan}
          verifyDiscountCode={verifyDiscountCode}
          clearDiscountCode={clearDiscountCode}
          handleCancel={handleCancelPackage}
          handleConfirm={handleSubscribe}
          invoice={invoice}
          gettingInvoice={gettingInvoice}
          storeStatus={storeStatus}
          remainCycles={remainCycles}
          history={history}
          subscribing={subscribing}
          useFreeVariant={useFreeVariant}
          packageSelected={packageSelected}
          setUpsellPackage={e => {
            setUpsellPackage(e);
          }}
        />
      )}

      {/* Modal: Request large plan */}
      <RequestLargeModal
        active={openRequestLarge}
        products={50000}
        handleCancel={handleCancelRequestLargeModal}
      />
      {/* Modal: Status success/fail after subscribe */}
      <StatusModal
        active={openModalStatus}
        infoStatus={renderContentSubscribeError()}
        secondaryAction={handleSupport}
        handleCancel={() => setOpenModalStatus(false)}
      />
      {/* Modal: Term and condition when applied discount */}
      <TermsConditionsModal
        onlyView={true}
        active={openTC}
        handleChangeModal={handledTermNCondition}
        content={termsConditionsContent}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  verifyDiscountCode: (code, subscribeOn, addOns, newPlanName) =>
    dispatch(subscriptionV3Actions.verifyDiscountCode(code, subscribeOn, addOns, newPlanName)),
  clearDiscountCode: () => dispatch(subscriptionV3Actions.clearDiscountCode()),
  subscribe: (planId, code, host, addOns) =>
    dispatch(subscriptionV3Actions.subscribe(planId, code, host, addOns, ownProps.i18n))
});

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const storeStatus = _.get(state.oauth, 'subscription.status', '');

  const host = _.get(state.oauth, 'host', '');

  const recentDiscountApplied = _.get(state.subscriptionV3, 'invoice.discountCodeApplied', '');
  const scopeDiscountCodeApplied = _.get(recentDiscountApplied, 'scope', '');

  const allowApplyDiscountCode =
    (recentDiscountApplied &&
      scopeDiscountCodeApplied === 'add-on' &&
      moment(recentDiscountApplied.expiredAt * 1000).isBefore(moment())) ||
    scopeDiscountCodeApplied === 'package' ||
    storeStatus === 'trial' ||
    _.isEmpty(scopeDiscountCodeApplied);

  return {
    tenantApp,
    host,
    storeStatus,
    allowApplyDiscountCode,
    selectedPlan: _.get(state.oauth.tenantApp, 'selectedPlan'),
    currentTotalProducts: _.get(tenantApp, 'appParams.currentTotalProducts'),
    verifying: _.get(state.subscriptionV3, 'verifying', false),
    remainCycles: _.get(state.subscriptionV3, 'remainCycles', 0),
    msgVerifyError: _.get(state.subscriptionV3, 'msgError', null),
    discount: _.get(state.subscriptionV3, 'discount', null),
    termsConditions: _.get(state.subscriptionV3, 'termsConditions', ''),
    subscribing: _.get(state.subscriptionV3, 'subscribing', false),
    subscription: _.get(state.oauth, 'subscription', {}),
    invoice: _.get(state.subscriptionV3, 'invoice', {}),
    gettingInvoice: _.get(state.subscriptionV3, 'gettingInvoice', false),
    allAddon: _.get(state.subscriptionV3, 'addons', [])
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(ActionChoosePackage));
